export const CURRENT_COLLECTION_ID = 'currentCollectionId';
